export const FOCUSED_TASK_EXPANDED_PARAM = 'expanded';

export const isFocusedTaskExpandedInUrl = (searchParams: URLSearchParams): boolean => searchParams.has(FOCUSED_TASK_EXPANDED_PARAM);

/** Expanded accordion targets the task id in the scan URL path only. */
export const readFocusedTaskExpandFromSearchParams = (
  searchParams: URLSearchParams,
  taskIdFromRoute?: string,
) => {
  const expanded = isFocusedTaskExpandedInUrl(searchParams);
  return {
    expanded,
    taskId: expanded ? taskIdFromRoute : undefined,
  };
};

export const writeFocusedTaskExpandToSearchParams = (
  searchParams: URLSearchParams,
  expanded: boolean,
) => {
  const next = new URLSearchParams(searchParams);
  if (expanded) {
    next.set(FOCUSED_TASK_EXPANDED_PARAM, '');
  } else {
    next.delete(FOCUSED_TASK_EXPANDED_PARAM);
  }
  return next;
};
